export enum OkrTeamType {
  subordinates = 'full',
  direct = 'direct',
}

export interface OkrMyTeamFilters {
  okrReviewCycleIds: number | string | null;
  teamType: OkrTeamType;
}
